import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useActiveCatalog } from '../hooks/useActiveCatalog';
import { featureFlags } from '../utils/featureFlags';

/**
 * GH#1254 — sticky banner shown while the account is in viewer mode because
 * EVERY owned catalog's subscription has expired. Mounted as a sibling of
 * IncidentBanner/NewVersionBanner in AppContent (inside ActiveCatalogProvider
 * so it can read `accountExpired`). Deliberately not dismissible: the state
 * itself is the message, and it clears the moment a catalog is reactivated.
 */
export function AccountExpiredBanner() {
  const { accountExpired } = useActiveCatalog();
  const navigate = useNavigate();

  if (!accountExpired || !featureFlags.isEnabled('enableExpiryLifecycle')) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={{ position: 'sticky', top: 0, zIndex: 1201, borderRadius: 0 }}
      data-testid="account-expired-banner"
      action={
        <Button color="inherit" size="small" onClick={() => navigate('/settings')}>
          Reactivate
        </Button>
      }
    >
      Your subscription has ended, so your catalogs are paused. Everything is preserved —
      reactivate any time to pick up where you left off.
    </Alert>
  );
}
